module.exports = __webpack_public_path__ + "img/ssbg11.5064ca47.jpg";